import React, { useEffect, useState } from "react";

export function LiveCounter({ te }) {
  // Smart fake counter that increments based on time of day
  const [count, setCount] = useState(() => {
    const now = new Date();
    const hourOfDay = now.getHours();
    const base = 220 + hourOfDay * 35;
    const jitter = Math.floor(Math.random() * 25);
    return base + jitter;
  });
  useEffect(() => {
    const tick = () => setCount((c) => c + 1);
    const id = setInterval(tick, 90000 + Math.random() * 60000); // every 1.5-2.5 min
    return () => clearInterval(id);
  }, []);
  const text = te.live_counter.template.replace("{n}", count.toLocaleString());
  return (
    <div className="bg-[#292524] text-white py-2.5" data-testid="live-counter">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-2.5 text-sm">
        <span className="relative flex w-2.5 h-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#3B8268] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#3B8268]"></span>
        </span>
        <span className="font-semibold">{text}</span>
      </div>
    </div>
  );
}
